<template>
  <div class="security-body">
    <div class="risk-tips">
      <span class="risk-tips-title">
        <span class="tips-title">
          <BlueTipsLogo/>
          <span class="prompt-title">风险提示</span>
        </span>
        <span class="tips-detail">
          <span class="tips-detail-search" @click="jumpToShowDeatil">查看详情</span>
          <span class="tips-detail-refresh" @click="toRefresh">刷新</span>
          <span class="tips-detail-endtime">最后更新时间   {{TimeUtils.dateTimeFormat(nowDate)}}</span>
        </span>
      </span>
      <span class="risk-tips-context">
        <div class="risk-rank-show rank-high" @click="jumpIntoHighRisklist">
          <div class="rank-title">
            <span>高风险</span>
            <span class="rank-totals rank-totals-high">{{riskRanktotal.highRisk}}</span>
          </div>
          <div class="rank-logo">
            <img :src="Images.RANK_HIGH" alt="">
          </div>
        </div>
        <div class="risk-rank-show rank-mid" @click="jumpIntoMidRisklist">
          <div class="rank-title" style="display:flex; flex-direction: column;">
            <span>中风险</span>
            <span class="rank-totals rank-totals-mid">{{riskRanktotal.mediumRisk}}</span>
          </div>
          <div class="rank-logo">
            <img :src="Images.RANK_MID" alt="">
          </div>
        </div>
        <div class="risk-rank-show rank-low" @click="jumpIntoLowRisklist">
          <div class="rank-title" style="display:flex; flex-direction: column;">
            <span>低风险</span>
            <span class="rank-totals rank-totals-low">{{riskRanktotal.lowRisk}}</span>
          </div>
          <div class="rank-logo">
            <img :src="Images.RANK_LOW" alt="">
          </div>
        </div>
      </span>
    </div>
    <div class="footer-box-container">
      <div class="login-limits">
        <span class="limit-tips-title">
          <span class="tips-title">
            <BlueTipsLogo/>
            <span class="limit-title">安全配置</span>
          </span>
          <!--span class="list-setting">
            <span class="black-white-list" @click="router.push(Page.SECURITY_CENTER_RISKIPOPERATION)">白名单设置</span>
          </span-->
        </span>
        <div class="limit-radio">
					<div>
						<el-icon style="color: #3D8EFF; transform: translateY(3px); margin-right: 4px;">
							<CollectionTag />
						</el-icon>登录IP白名单 
					</div>
					<div style="padding-left: 16px;line-height: 36px; margin-right: 20px; cursor:pointer; display: flex; flex-direction: row;" @click="editIpWhiteList">
						<div  v-if="securityConfig?.ipWhitelist" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
							允许以下IP登录 
							<span style="color:#3D8EFF; cursor: pointer;">{{ securityConfig?.ipWhitelist }}</span>
						</div>
						<div v-else>
							当前允许所有IP登录 
						</div>
						
						<div>
							<el-icon style="color: #3D8EFF; margin-left: 4px;"><EditPen /></el-icon>
						</div>
					</div>

                    <div style="padding-left: 16px;line-height: 36px; margin-right: 20px; cursor:pointer; display: flex; flex-direction: row;" @click="editEmployeeWhiteList">
						<div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
							允许以下员工登录不受IP限制 
							<span style="color:#3D8EFF; cursor: pointer;">{{ securityConfig?.employeeWhitelistNames }}</span>
						</div>
						
						<div>
							<el-icon style="color: #3D8EFF; margin-left: 4px;"><EditPen /></el-icon>
						</div>
					</div>

					<!--wx-->
					<div style="margin-top: 8px;">
						<el-icon style="color: #3D8EFF; transform: translateY(3px); margin-right: 4px;">
							<CollectionTag />
						</el-icon>开启微信绑定登录 
					</div>
					<div style="padding-left: 16px;line-height: 36px;">
						当前&nbsp;&nbsp;
						<el-tag :type="securityConfig?.weixinEnabled ? 'success' : 'info'" style="cursor: pointer;" @click="switchWeixin">
						{{ securityConfig?.weixinEnabled ? '已开启' : '未开启' }}
						</el-tag> 
					</div>
          <!--el-radio-group v-model="riskRanktotal.loginLimitWay" @change="limitRadioChange">
            <el-radio :label="0">方式一：任意IP都可以登录（默认）</el-radio>
            <el-radio :label="1">方式二：IP白名单之外需短信校验（员工白名单不限制）</el-radio>
            <el-radio :label="2">方式三：禁止IP白名单外的登录（员工白名名单不限制）</el-radio>
            <el-radio :label="3">方式四：IP白名单外需用短信校验登录（仅限员工白名单）</el-radio>
          </el-radio-group-->
        </div>
      </div>
      <div class="account-protect">
        <span class="limit-tips-title">
          <span class="tips-title">
            <BlueTipsLogo/>
            <span class="limit-title">密码保护</span>
          </span>
        </span>
        <span class="protect-radio-title">定期修改密码</span>
        <div class="protect-radio">
          <el-radio-group :modelValue="securityConfig?.pwdChgInterval" @change="modifyPwdChgInterval">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">1个月</el-radio>
            <el-radio :label="2">3个月</el-radio>
            <el-radio :label="3">半年</el-radio>
          </el-radio-group>
          <p v-if="currentAccountInfo.permission == 2" class="force-offline-ctn">
            在线员工查看，可强制下线     
            <el-button type="primary" class="force-offline-btn" link  @click="router.push(Page.SECURITY_FORCE_OFFLINE)">查看</el-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { Images } from "@/assets/Images";
import {  reactive, ref } from "vue"
import {Page} from "@/router";
import {useRouter} from "vue-router";
import BlueTipsLogo from "./BlueTipsLogo.vue"
import EmployeeWhitelistDialog from './dialog/EmployeeWhitelistDialog.vue'

// import { modifyPasswordRegularly, loginLimit, getSecurityCenterData } from "api/LoginAPI"
import { getTenantSecurityConfig, setTenantSecurityConfig } from "api/LoginAPI";

import { catchError, specTimeOutCheck  } from "@/utils/utils";
import {TimeUtils} from "utils/TimeUtils";

import { CollectionTag, EditPen } from '@element-plus/icons-vue';

// <el-icon><CollectionTag /></el-icon>
import * as easy from '@/components/easy';
import { currentAccountInfo } from "../../State";

const {data: securityConfig, load: refreshConfig } = easy.computedAsyncEx(async () => {
	const { response, error } = await catchError(getTenantSecurityConfig());
	if(error) throw new easy.IgnoreError();

	if(response?.code) throw new easy.TipError(response.message);

	return response!.data;
});

const editIpWhiteList = async () => {
	let ipWhitelist = '';
	try {
		ipWhitelist = await easy.prompt(() => <>
				<div style="color: #e6a23c">1. 设置IP白名单要谨慎，登录者IP不在指定中将无法登录</div>
				<div>2. 已登录用户不受影响, 下次登录生效</div>
				<div>3多个IP以逗号分隔; IP段使用CIDR表示法输入,例如:192.168.0.1/24(表示IP192.168.0.0-192.168.0.255)</div>
			</>, {
			inputValue: securityConfig.value.ipWhitelist,
			title: '登录IP白名单',
			confirmButtonText: '只允许指定IP',
			cancelButtonText: '清除IP限制',
			inputType: 'textarea',
			distinguishCancelAndClose: true,
			inputValidator: (v) => { 
				if(!v || !v.trim()) return '请输入IP地址'; 
				return true;
			}
		});
	} catch(e) {
		// 点取消按钮，清空IP白名单设置
		if((e as any).message != 'cancel') {
			throw e;
		}
	}

	const { response, error } = await catchError(setTenantSecurityConfig({
		ipWhitelist
	}));

	if(error) throw new easy.IgnoreError();
	if(response?.code) throw new easy.TipError(response.message);

	// 再调一次接口刷新UI
	refreshConfig(true);

}

const editEmployeeWhiteList = async () => {
	const employeeWhitelist = await easy.showDialog(EmployeeWhitelistDialog, {
        employeeWhitelist: securityConfig.value?.employeeWhitelist || []
    }, {
        title: '允许以下员工登录不受IP限制',
        size: "30%"
    })

	const { response, error } = await catchError(setTenantSecurityConfig({
		employeeWhitelist
	}));

	if(error) throw new easy.IgnoreError();
	if(response?.code) throw new easy.TipError(response.message);

	// 再调一次接口刷新UI
	refreshConfig(true);
}

// 开启或关系微信登录
const switchWeixin = async () => {
  await easy.confirm(() => 
		<>
			<div>{securityConfig.value.weixinEnabled ? '确定要“关闭”微信绑定登录吗？' : '确定要“开启”微信绑定登录吗？'}</div>
			<div>已登录用户不受影响, 下次登录生效</div>
		</>, {
			title: '微信登录'
		})

	const { response, error } = await catchError(setTenantSecurityConfig({
		weixinEnabled: !securityConfig.value.weixinEnabled
	}));

	if(error) throw new easy.IgnoreError();
	if(response?.code) throw new easy.TipError(response.message);

	// 再调一次接口刷新UI
	refreshConfig(true);
}

const modifyPwdChgInterval = async (value: number) => {
  await easy.confirm(() => 
		<>
			<div>确定要更改“定期修改密码”策略吗？</div>
			<div>超时未修改密码的员工, 下次登录即需要修改</div>
		</>, {
			title: '账号保护'
		})

	const { response, error } = await catchError(setTenantSecurityConfig({
		pwdChgInterval: value
	}));

	if(error) throw new easy.IgnoreError();
	if(response?.code) throw new easy.TipError(response.message);

	// 再调一次接口刷新UI
	refreshConfig(true);
}

interface RiskRankTotal {
  highRisk: number
  mediumRisk: number
  lowRisk: number
  loginLimitWay: number
  regularModifyPassword: number
}

const riskRanktotal = reactive<RiskRankTotal>({
  highRisk: 0,
  mediumRisk: 0,
  lowRisk: 0,
  loginLimitWay: 0,
  regularModifyPassword: 0
})

const tempLoginLimitWay = ref(0)
const tempRegularModifyPassword = ref(0)
// 获取当前日期
const nowDate = ref(0)
 nowDate.value = new Date().getTime()

//const accountMessageStore = useAccountMessageStore()

const router = useRouter()

const dialogVisible = ref(false)

const dialogShow = ref(false)

// onMounted(()=> {
//   getSecurityCenterInfo()
// })

// // 获取登录风险和限制、保护数据
// async function getSecurityCenterInfo () {
//   let loading = ElLoading.service()
//   let {response, error} = await catchError(getSecurityCenterData({
//     currentMerchantId: accountMessageStore.$state.merchantId,
//     currentNickName: accountMessageStore.$state.nickName
//   }, 5000))
//   loading.close()
//   if (error) {
//     if (specTimeOutCheck(error)) {
//       console.log('网络超时，请重试');
//     }
//   } else {
//     if(response?.code == 0) {
//       riskRanktotal.highRisk = response.data.highRisk
//       riskRanktotal.mediumRisk = response.data.mediumRisk
//       riskRanktotal.lowRisk = response.data.lowRisk
//       riskRanktotal.loginLimitWay = response.data.loginLimit
//       riskRanktotal.regularModifyPassword = response.data.modifyAccountPasswordRegularly
//       tempLoginLimitWay.value = response.data.loginLimit
//       tempRegularModifyPassword.value = response.data.modifyAccountPasswordRegularly
//     } else {
//       ElMessage.error(response?.message)
//     }
//   }
// }

// async function staffLoginLimit() {
//   let {response, error} = await catchError(loginLimit({
//     currentMerchantId: accountMessageStore.$state.merchantId,
//     currentNickName: accountMessageStore.$state.nickName,
//     loginLimit: riskRanktotal.loginLimitWay
//   }, 5000))
//   if (error) {
//     if (specTimeOutCheck(error)) {
//       ElMessage.error("程序员开小差了，请稍后重试");
//     }
//   } else {
//     if(response?.code == 0) {
//       ElMessage.success("修改成功")
//     } else {
//       ElMessage.error(response?.message)
//     }
//   }
// }

// async function regularModifyPassword() {
//   let {response, error} = await catchError(modifyPasswordRegularly({
//     currentMerchantId: accountMessageStore.$state.merchantId,
//     currentNickName: accountMessageStore.$state.nickName,
//     modifyPasswordRegularly: riskRanktotal.regularModifyPassword
//   }, 5000))
//   if (error) {
//     if (specTimeOutCheck(error)) {
//       ElMessage.error("程序员开小差了，请稍后重试");
//     }
//   } else {
//     if(response?.code == 0) {
//       ElMessage.success("修改成功")
//     } else {
//       ElMessage.error(response?.message)
//     }
//   }
// }

// const toConfirm = () => {
//   regularModifyPassword()
//   const timer = setTimeout(() => {
//     getSecurityCenterInfo()
//   }, 200);
//   dialogVisible.value = false
// }

// const toEnsure = () => {
//   staffLoginLimit()
//   const timer = setTimeout(() => {
//     getSecurityCenterInfo()
//   }, 200);
//   dialogShow.value = false
// }

// const toCancel = () => {
//   if(dialogVisible.value) {  
//     riskRanktotal.regularModifyPassword = tempRegularModifyPassword.value
//     dialogVisible.value = false
//   } 
//   if(dialogShow.value) {
//     riskRanktotal.loginLimitWay = tempLoginLimitWay.value
//     dialogShow.value = false
//   }
// }
// const modifyRadioChange = () => {
//   dialogVisible.value = true
// }

// const limitRadioChange = () => {
//   dialogShow.value = true
// }

// const jumpToShowDeatil = () => {
//   router.push({path: Page.SECURITY_CENTER_RISKLIST})
// }

// const jumpIntoHighRisklist = () => {
//   router.push({path: Page.SECURITY_CENTER_RISKLIST, query:{level: '高'}})
// }

// const jumpIntoMidRisklist = () => {
//   router.push({path: Page.SECURITY_CENTER_RISKLIST, query:{level: '中'}})
// }

// const jumpIntoLowRisklist = () => {
//   router.push({path: Page.SECURITY_CENTER_RISKLIST, query:{level: '低'}})
// }

// const emits = defineEmits(['toRefreshData'])
  
// const toRefresh = () => {
//   emits('toRefreshData')
//   nowDate.value = new Date().getTime()
// }

</script>

<style lang="scss" scoped>
.security-body {
  font-family: PingFangSC-Regular, PingFang SC;
  margin-top: 40px;
  width: 984px;

.risk-tips{
  margin-top: -8px;
  display: flex;
  width: 984px;
  height: 40%;
  flex-direction: column;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 18px 0px rgba(215, 222, 233, 0.4);
  border-radius: 4px;
  }
}

.security-body .footer-box-container{
  height: 60%;
  display: flex;
  flex-direction: row;
  .login-limits{
    margin-top: 22px;
    width: 484px;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 18px 0px rgba(215, 222, 233, 0.4);
    border-radius: 4px;
  }

  .account-protect{
    margin-top: 22px;
    margin-left: 16px;
    width: 484px;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 18px 0px rgba(215, 222, 233, 0.4);
    border-radius: 4px;
  }
}

.risk-tips-title, .limit-tips-title{
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.tips-title{
  display: flex;
  flex-direction: row;
  align-items: center;

  .prompt-title, .limit-title{
    margin-left: 16px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

}

.list-setting{
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #3D8EFF;
  cursor: pointer;
  margin-right: 16px;
}

.limit-radio{
  margin-left: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
}

.tips-detail{
  width: 400px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .tips-detail-search, .tips-detail-refresh{
    cursor: pointer;
    font-size: 14px;
    color: #3D8EFF;
  }

  .tips-detail-endtime{
    font-size: 14px;
    color: #606266;
    margin-right: 16px;
  }
}

.risk-tips-context{
  display: flex;
  border: #303133;
  width: 952px;
  height: 172px;
  margin-left: 16px;
  justify-content: space-between;
}

.risk-rank-show{
  cursor: pointer;
  height: 170px;
  width: 306px;
  border-radius: 4px;
  display: flex;
  justify-content: flex-end;

  .rank-logo{
    width: 66px;
    height: 66px;
  }

  .rank-title{
    font-size: 18px;
    color: #606266;
    font-weight: 500;
    line-height: 25px;
    margin-right: 154px;
    margin-top: 28px;
    display:flex;
    flex-direction: column
  }


}

.risk-tips-context{
  .rank-high{
    background:linear-gradient(#FEF4F1 0%, #FEFEFF 100%);
  }

  .rank-mid{
    background:linear-gradient(#FEF9EF 0%, #FEFEFF 100%)  ;
  }

  .rank-low{
    background:linear-gradient(#F2F8FF 0%, #FEFEFF 100%)  ;
  }

  .rank-totals-high{
    color: #FF5125;
  }

  .rank-totals-mid{
    color: #FCBD40;
  }

  .rank-totals-mid{
    color: #3D8EFF;
  }
}
 
.rank-totals{
  font-family: HelveticaNeue-BoldItalic, HelveticaNeue;
  font-size: 26px;
  font-weight: 600;
  margin-top: 30px;
  line-height: 32px;
  font-style: oblique;
}

.protect-radio-title{
  margin-left: 22px;
  margin-top: 18px;
  font-weight: 400;
  color: #303133;
}

.protect-radio{
  margin-top: 20px;
  margin-left: 20px;
  .force-offline-ctn{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303133;
  }
  .force-offline-btn{
    font-size: 14px;
  }
}

.black-white-list{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

</style>